import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

const logPersistenceError = (operation: string, error: unknown) => {
  if (import.meta.env.DEV) {
    console.warn(`Failed to ${operation} React Query cache`, error);
  }
};

/**
 * Creates an Indexed DB persister for TanStack Query
 */
export function createWebPersister(idbValidKey = 'tanstack-query-cache'): Persister {
  return {
    persistClient: async (client: PersistedClient) => {
      try {
        await set(idbValidKey, client);
      } catch (error) {
        logPersistenceError('persist', error);
      }
    },
    restoreClient: async () => {
      return await get<PersistedClient>(idbValidKey);
    },
    removeClient: async () => {
      try {
        await del(idbValidKey);
      } catch (error) {
        logPersistenceError('remove', error);
      }
    },
  };
}
